import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/booking/predefined-lists/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) =>
        api.get(`/booking/predefined-lists`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/booking/predefined-lists/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/booking/predefined-lists`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/booking/predefined-lists/${url.id}`, data, config),
    patch: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.patch(`/booking/predefined-lists/${url.id}`, data, config),
};

export default requests;
